import React from 'react';
import { useHistory, useParams } from 'react-router';

// mui
import { Typography } from '@mui/material';

// wrappers
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper'

// collections
import CrewMembersForJobDay from './collections/CrewMembersForJobDay/CrewMembersForJobDay.collection';
import JobInfo from './collections/JobInfo/JobInfo.collection';
import JobDayNameAndDate from './collections/JobDayNameAndDate/JobDayNameAndDate.collection';
import JobDayActions from './collections/JobDayActions/JobDayActions.collection';

// apollo
import { GET_JOB_DAY_CREW_ASSIGNMENTS } from '../../../graphql/jobDay/jobDay.queries';

export default function JobDayDetails() {
    const { jobDayId } = useParams()
    const history = useHistory()

    // ✅ FIX: Convert string to integer
    const parsedJobDayId = parseInt(jobDayId, 10)

    // ✅ Optional: Add validation
    if (isNaN(parsedJobDayId)) {
        return <Typography variant="h4">Invalid Job Day ID</Typography>
    }

    return (<div>

        {/* ✅ Use parsedJobDayId (integer) instead of jobDayId (string) */}
        <JobDayNameAndDate jobDayId={parsedJobDayId} />

        <WithGqlQuery 
            component={JobDayActions}
            query={GET_JOB_DAY_CREW_ASSIGNMENTS}  
            variables={{ id: parsedJobDayId }}  // ✅ Fixed
            id={parsedJobDayId}                   // ✅ Fixed
        />

        <JobInfo jobDayId={parsedJobDayId} />    {/* ✅ Fixed */}
        
        <Typography variant="h4">Crew Members</Typography>
        <WithGqlQuery 
            component={CrewMembersForJobDay} 
            query={GET_JOB_DAY_CREW_ASSIGNMENTS} 
            variables={{ id: parsedJobDayId }}  // ✅ Fixed
            id={parsedJobDayId}                   // ✅ Fixed
        />
        
    </div>)
}